export namespace BenutzerModels {

    // Diese Konfiguration wird nur für den aktuellen Browser/ServiceWorker gespeichert und nicht via Webservice in der Navi-DB
    export interface WebUserConfig {
        debugMode: boolean;
        treeViewEmployee?: boolean;
        treeViewCache?: boolean;
        // TODO in 2.18.290 remove  https://swissjira.atlassian.net/browse/EN-4409
        partialTreeMode?: boolean;
        sortTreeView?: boolean;
    }

    export const DefaultWebUserConfig = (): BenutzerModels.WebUserConfig => ({
        debugMode: false,
        treeViewEmployee: true,
        // TODO remove in 2.18.290 https://swissjira.atlassian.net/browse/EN-4409
        partialTreeMode: true,
        sortTreeView: true
    });

    export interface Anwender {
        employeeID: number;
        mandatorID: string;
        mandator: string;
        firstName: string;
        lastName: string;
        shortName: string;
        costCenter: number;
        sA_ShowExpense?: number;
        sA_ShowGoodwill?: number;
        sA_InsertTimesAuto?: number;
        sA_DeleteDataAfter?: number;
        sA_ShowPrices?: number;
        sA_EditChecklist?: number;
        sA_HoursText?: string;
        sA_RoundTimes?: number;
        sA_PercentageIncidentals?: number;
        sA_PercentageVAT?: number;
        sA_DefaultCostCenter?: number;
        sA_ShowWorkplace?: number;
        sA_DashboardIntervall?: number;
        sA_Dontsendtimestotimecontrol?: number;
        sA_ShowExpenseInRapport?: number;
        sA_TransferImages?: number;
        userID: number;
        loginname: string;
        orderSourceVinavonTime: number;
        allowRecordingMaterial: boolean;
    }

    export class EmptyAnwender implements Anwender {
        employeeID: number;
        mandatorID: string;
        mandator: string;
        firstName: string;
        lastName: string;
        shortName: string;
        costCenter: number;
        userID: number;
        loginname: string;
        orderSourceVinavonTime: number;
        allowRecordingMaterial = false;

        constructor() {
            this.employeeID = 0;
            this.mandatorID = '100';
            this.mandator = 'DEMO';
            this.firstName = 'DEMO';
            this.lastName = 'DEMO';
            this.shortName = 'DEMO';
            this.costCenter = 0;
            this.userID = 0;
            this.loginname = 'demo';
            this.orderSourceVinavonTime = 1;
        }
    }

    export interface Benutzer {
        userName: string;
        userPW: string;
        mandantID: string;
        mandant: string;
        clearName?: string;
    }

    export class EmptyUser implements Benutzer {
        userName: string;
        userPW: string;
        mandantID: string;
        mandant: string;

        constructor() {
            this.userName = '';
            this.userPW = '';
            this.mandant = '';
            this.mandantID = '';
        }
    }

    export interface Keys {
        p256dh: string;
        auth: string;
    }

    export interface MessageReceiver {
        endpoint: string;
        exipirationTime: string;
        keys: Keys;
    }

    export interface BenutzerRecht {
        rightsID: number;
        value: number;
        groupValue: number;
        effectiveValue: number;
        rightsGrpText: string;
        rightsText: string;
        textOrder: number;
        orderID: number;
        groupOrder: number;
    }

    export interface BenutzerRechtObjekt {
        rightsID: number;
        value: number;
        groupValue: number;
        effectiveValue: number;
    }

    export interface RechtGruppeReihenfolge {
        orderID: number;
        rightsGrpText: string;
        textOrder: number;
        groupOrder: number;
    }

    export interface BenutzerRechtListElement {
        ID: number;
        HatRecht: number;
        HatGruppenRecht: number;
        HatEffektivRecht: number;
        Gruppe: string;
        Rechtbeschreibung: string;
        Reihenfolge: number;
        OrderID: number;
        GroupOrder: number;
    }

    export interface BenutzerGruppe {
        gruppeID: number;
        gruppe: string;
    }

    export interface BenutzerAnwendung {
        benutzerLizenzen: BenutzerLizenz[];
        benutzerModule: BenutzerModul[];
        otherRegistrationExists: boolean;
    }

    export interface BenutzerLizenz {
        lizenzName: string;
    }

    export interface BenutzerModul {
        iD_SwissModule: number;
        module: string;
    }

    export enum UserRightCodes {
        ObjekteLoeschen = 3,
        ObjekteErstellen = 4,
        ObjekteMutieren = 6,
        ObjekteLiegenschaftErstellen = 100010001,
        ObjekteAuftragErstellen = 100010002,
        ObjekteOrdnerErstellen = 100010003,
        ObjekteProdAuftragErstellen = 100010004,
        ObjekteLieferantErstellen = 100010005,
        ObjekteMitarbeiterErstellen = 100010006,
        ObjekteKundeErstellen = 100010007,
        AdresseMutieren = 8,
        AdresseErstellen = 16,
        AdresseLoeschen = 17,
    }

    export enum UserLicenses {
        CMobileTime = 'CMobileTime',
        CServiceApp = 'CSERVICEAPP',
        CNavigatorMobile = 'CNavigatorMobile'
    }

    export enum UserModules {
        NavigatorMobile = 1,
        CMobileTime = 2,
        CServiceApp = 3,
        CNavigatorMobile = 4,
        CMobileTimePlus = 5, // not in use
    }
}
